import React from 'react';
import { isCanadianZipcode } from '../../utils/validation';

export const zipcodeMessage = (zipcode: string) => {
    if (isCanadianZipcode(zipcode)) {
        return <div className="warning-message" > Check with local jurisdiction to verify loading conditions </div>
    }
}
